import { gql } from "@apollo/client";

export default gql`
  mutation createProgramScheduledReminderMutation(
    $complianceProgramId: Int!
    $message: String!
    $nominations: Boolean!
    $oneonone: Boolean!
    $performanceAssessment: Boolean!
    $performanceSelfAssessment: Boolean!
    $managerAssessment: Boolean!
    $peerAssessment: Boolean!
    $engagementSurvey: Boolean!
    $emailNotification: Boolean!
    $slackNotification: Boolean!
    $daysAfterStartDate: Int!
    $sendNow: Boolean
  ) {
    createComplianceProgramScheduledReminder(
      complianceProgramId: $complianceProgramId
      nominations: $nominations
      oneonone: $oneonone
      performanceAssessment: $performanceAssessment
      performanceSelfAssessment: $performanceSelfAssessment
      managerAssessment: $managerAssessment
      peerAssessment: $peerAssessment
      engagementSurvey: $engagementSurvey
      message: $message
      emailNotification: $emailNotification
      slackNotification: $slackNotification
      daysAfterStartDate: $daysAfterStartDate
      sendNow: $sendNow
    ) {
      complianceProgram {
        id
      }
      reminder {
        id
      }
    }
  }
`;
